// src/components/layout/Header.js
import React, { useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { SidebarContext } from '../../context/SidebarContext';
import logo from '../../assets/images/onspot-icon.png';
import { FaHome, FaBars, FaTimes, FaUserCircle, FaUserEdit, FaSignOutAlt } from 'react-icons/fa';
import { Dropdown } from 'react-bootstrap';
import './Header.css'; 

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useContext(AuthContext);
  const sidebarContext = useContext(SidebarContext);
  const sidebarOpen = sidebarContext ? sidebarContext.sidebarOpen : false;
  const toggleSidebar = sidebarContext ? sidebarContext.toggleSidebar : null;
  const [fallbackOpen, setFallbackOpen] = useState(false);

  const showSidebarToggle =
    location.pathname.startsWith('/admin') ||
    location.pathname.startsWith('/examiner') ||
    location.pathname.startsWith('/archiver') ||
    location.pathname.startsWith('/data-team') ||
    location.pathname.startsWith('/security')
  const isLoginPage = location.pathname === '/login' || location.pathname === '/';

  const handleFallbackToggle = () => {
    const sidebarEl = document.querySelector('.sidebar');
    if (sidebarEl) {
      sidebarEl.classList.toggle('open');
      setFallbackOpen(sidebarEl.classList.contains('open'));
    }
  };

  const handleToggle = () => {
    if (toggleSidebar) {
      toggleSidebar();
    } else {
      handleFallbackToggle();
    }
  };

  const isSidebarOpen = toggleSidebar ? sidebarOpen : fallbackOpen;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Helper to get the correct profile picture URL
  const getProfilePicUrl = (profilePicture) => {
    if (!profilePicture) return null;
    if (profilePicture.startsWith('http')) return profilePicture;
    return `${process.env.REACT_APP_FILE_BASE_URL}/${profilePicture.replace(/\\/g, '/')}`;
  };

  return (
    <nav className="navbar navbar-expand-lg" style={{ backgroundColor: '#050f5e' }}>
      <div className="container-fluid">
        {/* Left side: toggle button, logo, and title */}
        <div className="d-flex align-items-center">
          {showSidebarToggle && (
            <button className="btn btn-outline-light me-2" onClick={handleToggle}>
              {isSidebarOpen ? <FaTimes /> : <FaBars />}
            </button>
          )}
          <img src={logo} alt="UVTAB OnSpot" style={{ height: '40px', borderRadius: '8px' }} className="me-2" />
          <span
            className="h4 mb-0 text-white navbar-brand-text"
            style={{ fontFamily: 'var(--font-sans)' }}
          >
            UVTAB OnSpot
          </span>
        </div>

        
        {!isLoginPage && (
          <div className="d-flex align-items-center">
            
            <button
              className="btn btn-outline-light me-2 rounded-circle"
              onClick={() => navigate('/')}
              title="Home"
              style={{ width: '40px', height: '40px', padding: 0 }}
            >
              <FaHome />
            </button>
            {user && (
              <Dropdown align="end">
                <Dropdown.Toggle
                  variant="outline-light"
                  id="dropdown-profile"
                  className="profile-toggle p-0 border-0"
                  caret={false}
                  style={{ background: 'transparent' }}
                >
                  {user.profilePicture ? (
                    <img
                      src={getProfilePicUrl(user.profilePicture)}
                      alt="Profile"
                      style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                    />
                  ) : (
                    <FaUserCircle style={{ fontSize: '2rem', color: '#fff' }} />
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => navigate('/profile/edit')}>
                    <FaUserEdit className="me-2" /> Edit Profile
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout}>
                    <FaSignOutAlt className="me-2" /> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {user && (user.fullName || user.role) && (
              <span
                className="text-white ms-2 d-none d-md-inline"
                style={{ fontFamily: 'var(--font-sans)', fontSize: '0.95rem' }}
              >
                {user.fullName}
                {user.role && (
                  <> ({user.role.charAt(0).toUpperCase() + user.role.slice(1)})</>
                )}
              </span>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}

export default Header;
